module.exports = __webpack_public_path__ + "static/media/icon-instagram.ef4642c5.svg";